angular.module("ainapp")
    .controller("ProductDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Product Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.load = false;
                $scope.VoucherDesign = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetProductDesign().then(function (response) {
                    $scope.VoucherDesign = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


                $scope.ViewVal = 0;

            }
            $scope.Init();


            $scope.SaveData = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.load = true;
                MainService.AddProductDesign($scope.VoucherDesign).then(function (response) {
                    $scope.load = false;
                    if (response) {
                        toastr.success("Success");
                        $scope.Init();
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



      }]);
